(function() {
	const productInformation = document.querySelector('.main-product');
	const productAddToCart = document.querySelector('.main-product__sticky-add-to-cart');

	const options = {
		root: null,
		rootMargin: '0px 0px 0px 0px',
		threshold: 0.35
	}

	const callback = (entries) => {
		entries.forEach((entry) => {

			if (entry.isIntersecting) {
				productAddToCart.classList.remove('visible');
				productAddToCart.setAttribute('aria-hidden', true);
				if (document.querySelector('.announcement-bar') != null) {
					document.querySelector('.announcement-bar .swiper').style.zIndex = 1
				}

			} else {
				if (window.scrollY >= document.querySelector('.main-product__info .product-form__submit').offsetTop) {
					productAddToCart.classList.add('visible');
					productAddToCart.setAttribute('aria-hidden', false);
					if (document.querySelector('.announcement-bar') != null) {
						document.querySelector('.announcement-bar .swiper').style.zIndex = 0
					}
				}
			}
			
		})
	};

	const observer = new IntersectionObserver(callback, options);
	observer.observe(productInformation);
})();